import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var WarningSVG = function WarningSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.75 26l-12-22a2 2 0 00-3.52 0l-12 22A2 2 0 004 29h24a2 2 0 001.75-3zM17.5 24a1.5 1.5 0 01-3 0 1.49 1.49 0 011.5-1.5 1.48 1.48 0 011.5 1.5zm-.44-4.83a1.09 1.09 0 01-2.11 0l-.69-6.4a1.74 1.74 0 113.48 0z"
  }));
};
WarningSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(WarningSVG);